import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import CheckboxTableCell from 'components/common/table/CheckboxTableCell';
import IconButton from 'components/common/buttons/IconButton';

const ScheduleTypeCellParamTemplateListItem = ({ data, handleDelete, canWrite }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(
    id => {
      historyContext.push(`/scheduleTypeCellParamTemplates/${id}`);
    },
    [historyContext]
  );

  return (
    <TableRow hover key={data.scheduleTypeCellParamTemplateId}>
      <TableCell>{data.templateName} </TableCell>
      <CheckboxTableCell disabled={true} checked={Boolean(data.activeYN)} />
      <TableCell>
        <IconButton
          type={canWrite ? 'edit' : 'view'}
          size='small'
          color='transparent'
          tooltip={canWrite ? t('Edit') : t('View')}
          onClick={() => handleEdit(data.scheduleTypeCellParamTemplateId)}
        />
        <IconButton
          type='delete'
          size='small'
          color='transparent'
          tooltip={t('Delete')}
          onClick={() => handleDelete(data.scheduleTypeCellParamTemplateId)}
          disable={!canWrite}
        />
      </TableCell>
    </TableRow>
  );
};

ScheduleTypeCellParamTemplateListItem.propTypes = {
  data: PropTypes.object.isRequired,
  handleDelete: PropTypes.func.isRequired,
  canWrite: PropTypes.bool.isRequired
};

export default ScheduleTypeCellParamTemplateListItem;
